const clearAuthToken = () => {
  if (localStorage) {
    localStorage.removeItem('token');
  } else {
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
};

export default clearAuthToken;
